import { Button } from '@/components/ui/button';
import { LogoFull } from '@/components/ui/logo';
import { startGoogleLogin } from '@/hooks/useAuth';
import { LanguagePicker } from '@/components/layout/LanguagePicker';
import { useT } from '@/lib/i18n';

export function LoginRoute() {
  const t = useT();
  // A failed or cancelled sign-in comes back with ?error=… from the callback.
  const error = new URLSearchParams(window.location.search).get('error');

  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <LogoFull />
        </div>

        <h1 className="mb-1.5 text-2xl font-semibold tracking-tight">
          {t('login.tagline')}
        </h1>
        <p className="mb-6 text-sm text-content-muted">{t('login.promise')}</p>

        {error ? (
          <div
            className="mb-4 rounded-md border border-overdue-border bg-overdue-subtle px-3 py-2"
            role="alert"
          >
            <p className="text-sm text-overdue">
              {error === 'access_denied' ? t('login.cancelled') : t('login.failed')}
            </p>
          </div>
        ) : null}

        <Button
          variant="primary"
          size="lg"
          className="w-full"
          onClick={startGoogleLogin}
        >
          {t('login.google')}
        </Button>

        <p className="mt-4 text-xs text-content-subtle">{t('login.privacy')}</p>

        {/* Before sign-in there is no account to read a preference from, so the
            picker is here too — otherwise the first screen anyone sees is in
            whatever language their browser happens to advertise. */}
        <div className="mt-6 border-t border-border pt-4">
          <LanguagePicker label={t('login.language')} />
        </div>
      </div>
    </div>
  );
}
